import React, {useState} from 'react'
import { Row, Col, Container, Button } from 'react-bootstrap'; 
import TypeAnimation from 'react-type-animation';
import { CharacterMap, DocumentLoadEvent, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { bookmarkPlugin } from '@react-pdf-viewer/bookmark';
import { Worker } from '@react-pdf-viewer/core';

import pdfFile from './../file/document.pdf'

export default function Resume() {

	const bookmarkPluginInstance = bookmarkPlugin();

	const handleDocumentLoad = (e: DocumentLoadEvent) => {
	    console.log(`Number of pages: ${e.doc.numPages}`);
	};

	const characterMap: CharacterMap = {
	    isCompressed: true,
	    url: 'https://unpkg.com/pdfjs-dist@2.6.347/cmaps/',
	};

	const [show, setShow] = useState(false)

    const downloadOnButtonClick = () => {
        fetch('/file/miguel_cv_PDF.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = '/file/miguel_cv_PDF.pdf';
                alink.click();
            })
        })
    }

	const viewCV = () => {
       if (show) {
       	 setShow(false);
       } else {
       	  setShow(true);
       }
	}

    return (
    	<Container id="cv" className="text-center mb-5">
    		<TypeAnimation
    		  cursor={false}
    		  sequence={[ 
    		     'Curriculum Vitae', 1000, 
    		     'Summary', 1000, 
    		     'CV', 1000, 
    		     'Career', 1000, 
    		     'Bio', 1000, 
    		     'Abstract', 3000,
    		     'Curriculum Vitae', 1000]}
    		  wrapper="p"
    		  className="about-me-label mt-1"
    		/>

    		<Row>
    		    {
    		    	show ?
    		    	    <>
    		    	       <Col lg={12} xs={12} md={7}>
	    		    	       	<Button 
	    		    	       		id="show-cv" 
	    		    	       		className="mt-4 mb-5"
	    		    	       		variant="light"
	    		    	       		onClick={() => viewCV()}
	    		    	       		>
	    		    	       		Hide CV
	    		    	       	</Button>
    		    	       </Col>
	    				   <Col lg={7} xs={12} md={7}>
    	    				    <div className="pdf-container">
        		    				<Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
        		    					<Viewer 
        		    				       fileUrl={pdfFile}
        		    				       defaultScale={SpecialZoomLevel.PageFit}
        		    				       plugins={[bookmarkPluginInstance]}
        		    				       onDocumentLoad={handleDocumentLoad} 
        		    				       characterMap={characterMap}
        		    					/>
        		    				</Worker>
    	    				    </div>
	    					</Col> 
                            <Col lg={5} xs={12} md={5}>
                                <Button 
                                    id="show-cv" 
                                    className="mt-4 mb-1"
                                    onClick={() => downloadOnButtonClick()}
                                    variant="light"
                                >
                                    Download CV
                                </Button>
                                <p id="dl-cv">
                                    File Updated: October 2022
                                </p>
                            </Col>
	    				</> 		    	   
    		    	:
    		    	   <>
    		    	   	   <Col lg={12} xs={12} md={7}>
    		    	   	   	<Button 
    		    	   	   		id="show-cv" 
    		    	   	   		className="mt-4 mb-5"
    		    	   	   		onClick={() => viewCV()}
    		    	   	   		variant="light"
    		    	   	   	>
    		    	   	   		Show CV
    		    	   	   	</Button>
    		    	   	   </Col>
    		    	   </>
    		    }

    		</Row>
    	</Container>
    );
};